// Frontend copy of backend/utils/overrideJustification.js — keep the two
// lists in sync. Used to warn the recruiter WHILE typing an override
// justification, before the backend rejects it on save.
const DRAFT_PATTERNS = [
  { re: /\bshould\s+(be\s+)?confirm(ed)?\b/i, label: "should be confirmed" },
  { re: /\b(needs?|must|has)\s+to\s+be\s+confirmed\b|\bto\s+be\s+confirmed\b/i, label: "to be confirmed" },
  { re: /\bconfirm(ed)?\s+(it\s+)?(directly\s+)?with\s+the\s+candidate\b/i, label: "confirm with the candidate" },
  { re: /\brecruiter\s+should\b/i, label: "recruiter should" },
  { re: /\b(not|never)\s+(been\s+)?(directly|actually)\s+used\b|\b(has|have)\s*n[o']t\s+(directly|actually)\s+used\b|\bhasn't\s+(directly\s+)?used\b/i, label: "has not directly used" },
  { re: /\bno\s+direct\s+(experience|use|usage)\b|\brather\s+than\s+direct\b/i, label: "no direct experience" },
  { re: /\b(not|un)\s*confirmed\b/i, label: "not confirmed" },
  { re: /\bplausibl[ey]\b/i, label: "plausible / plausibly" },
  { re: /\bcould\s+reasonably\b|\bmay\s+have\b|\bmight\s+have\b|\blikely\s+(used|involved|required)\b|\bpresumably\b/i, label: "could / may / might have" },
  { re: /\binferred\b|\bnot\s+called\s+out\b|\bno\s+mention\b|\bnot\s+mentioned\b/i, label: "inferred / not mentioned" },
  { re: /\btransferable\s+skill\b|\bwould\s+transfer\b/i, label: "transferable skill" },
];

// @returns string[] — labels of every draft phrase found (empty = OK)
export function findDraftLanguage(text) {
  const str = String(text || "");
  return DRAFT_PATTERNS.filter((p) => p.re.test(str)).map((p) => p.label);
}
